import { useEffect, useState } from "react";
import { lumiFetch, setLumiToken } from "./lumiApi";

// Handles the post-login redirect from auth.emergentagent.com
// URL fragment looks like:  #session_id=xxxxxxxxxxxx
export default function LumiAuthCallback({ onSuccess, onError }) {
  const [status, setStatus] = useState("processing");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      onError && onError("Missing session_id");
      return;
    }
    const session_id = m[1];

    lumiFetch("/auth/session", {
      method: "POST",
      body: JSON.stringify({ session_id }),
    })
      .then((user) => {
        // Belt-and-braces: store token in localStorage so Authorization header works
        // even if the Set-Cookie gets dropped by Safari ITP or other browser policies.
        if (user?.session_token) setLumiToken(user.session_token);
        // Clean the URL
        window.history.replaceState({}, "", "/lumi");
        setStatus("ok");
        onSuccess && onSuccess(user);
      })
      .catch((err) => {
        const msg = err?.data?.detail || err?.message || "Could not sign in";
        setErrorMsg(msg);
        setStatus("error");
        onError && onError(msg);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "error") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white p-6" data-testid="lumi-auth-error">
        <div className="max-w-md text-center">
          <p className="text-2xl mb-3">🚫 Access denied</p>
          <p className="text-sm text-white/70 mb-6">{errorMsg}</p>
          <a href="/lumi" className="inline-block px-5 py-2 border border-white/40 rounded-full text-sm hover:bg-white/10">
            Try again
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white" data-testid="lumi-auth-processing">
      <div className="text-center">
        <div className="animate-pulse text-2xl mb-3">✨</div>
        <p className="text-sm text-white/70">Signing you in…</p>
      </div>
    </div>
  );
}
